import { memo } from 'react';
import { format } from 'date-fns';

import type { EventModel } from 'models';

import { Container, Text, Subject } from './style';

interface MessageWidgetItemProps {
  message: EventModel;
  onClick?: (id: string) => void;
}

const MessageWidgetItem = ({ message, onClick }: MessageWidgetItemProps) => {
  const handleClick = () => {
    if (onClick) {
      onClick(message.Id);
    }
  };

  return (
    <Container direction="row" spacing={1} onClick={handleClick}>
      <Subject>{message.Subject}</Subject>
      <Text>
        {message.CreatedOn && format(new Date(message.CreatedOn), 'd.M.yyyy')}
      </Text>
    </Container>
  );
};

export default memo(MessageWidgetItem);
